interface IPlusSquare {
    fill?: string,
    width?: string,
    height?: string
}

const PlusSquare = ({ fill, width, height }: IPlusSquare) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width || "20"} height={height || "20"} viewBox="0 0 20 20" fill={fill || "none"}>
            <rect x="2" y="2" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.4"/>
            <path d="M6 10L14 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 6V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default PlusSquare;